module.exports = __webpack_public_path__ + "sansg/img/9.7b9abd39.png";